import { useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../api/auth";
import { ApiError } from "../api/client";
import "./LoginView.css";

export default function ResetPasswordView() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authApi.resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <h1>chatter</h1>
          <div className="login-error">Missing reset token.</div>
          <div className="login-footer-links">
            <Link to="/forgot-password">Request a new link</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <h1>Set a new password</h1>
        {done ? (
          <p>Password updated — redirecting to sign in…</p>
        ) : (
          <>
            <label>
              New password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
              />
            </label>
            {error && <div className="login-error">{error}</div>}
            <button type="submit" disabled={loading}>
              {loading ? "Saving…" : "Update password"}
            </button>
          </>
        )}
        <div className="login-footer-links">
          <Link to="/login">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
